// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0af39837","453":"4788a7b1","455":"eb2ce270","977":"dff227d4"}[chunkId] + ".chunk.js";
};